import { useMutation } from 'react-query';
import {
  fetchPartnerExaminationJWTForExams,
  fetchPartnerExaminationJWTForVisits,
} from '@higo/api/lib/services';
import { useMicrositeApiContext } from 'contexts/MicrositeApiContext';

// export const useExchangePartnerOTPForJWTMutation = () => {
//   const { baseAxios } = useMicrositeApiContext();

//   return useMutation(fetchPartnerExaminationJWT(baseAxios));
// };

export const useExchangePartnerOTPForExamsJWTMutation = () => {
  const { baseAxios } = useMicrositeApiContext();

  return useMutation(fetchPartnerExaminationJWTForExams(baseAxios));
};

export const useExchangePartnerOTPForVisitsJWTMutation = () => {
  const { baseAxios } = useMicrositeApiContext();

  return useMutation(fetchPartnerExaminationJWTForVisits(baseAxios));
};
